/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { TouchableOpacity } from 'react-native';

import Colors from '@global/colors';
import { ARROW_SIZE } from '@/constants';

import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

const SelectItem = ({ item, arrow, onPress }) => {
  return (
    <TouchableOpacity
      onPress={() => onPress()}
      activeOpacity={0.6}
      style={{
        width: '100%',
        padding: 15,
        borderBottomColor: Colors.grey0,
        borderBottomWidth: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <SociollaText type="medium">{item.label}</SociollaText>
      {arrow ? (
        <Image
          style={[ARROW_SIZE, { transform: [{ rotate: '-90deg' }] }]}
          width={ARROW_SIZE.width}
          height={ARROW_SIZE.height}
          svg={true}
          source={require('@assets/img/icons/arrow-down-grey.svg')}
        />
      ) : (
        false
      )}
    </TouchableOpacity>
  );
};

export default SelectItem;
